import styled from 'styled-components';

export const Value = styled.span`
  display: block;
  width: 16px;
  height: 16px;
  border-radius: 50%;
  border: 1px solid var(--aluminium75);
`;

export const Label = styled.label`
  position: absolute;
  cursor: pointer;
`;

export const Input = styled.input`
  position: absolute;
  opacity: 0;
  visibility: hidden;
  width: 0;
  height: 0;

  &:checked + ${Value} {
    border-color: #0f71d4;
    border-width: 5px;
  }

  &:disabled + ${Value} {
    border-color: var(--aluminium60);
  }
`;
